import './styles/index.scss';
import '@fontsource/lato';

import Routing from './routing';
import { useEffect, useState } from 'react';
import { CookiesProvider } from 'react-cookie';
import { CustomProvider } from 'rsuite';
import * as locales from 'rsuite/locales';
import { useTranslation } from 'react-i18next';
import { jaJP } from '@monorepo/shared/i18n/jaJP/rsLocale';
import '@monorepo/shared/i18n/config';
import { getNavigatorLanguage, useAppSelector } from '@monorepo/shared';
import { selectCurrentLocale } from '@monorepo/shared/store/authSlice';

function App() {
  const isDarkTheme = true;
  const [darkMode, setDarkMode] = useState(isDarkTheme);

  const languages: Record<string, any> =
    locales && jaJP ? { ...locales, jaJP: jaJP } : {};
  const currentLocale: string = useAppSelector(selectCurrentLocale);
  const [localeVal, setLocaleVal] = useState<any>();
  const { i18n } = useTranslation();
  useEffect(() => {
    if (locales && Object.keys(languages).length) {
      const locale =
        currentLocale === 'auto' ? getNavigatorLanguage() : currentLocale;
      const value = languages[locale];
      if (value) {
        setLocaleVal(value);
        i18n.changeLanguage(locale);
      } else if (locale === 'jaJP') {
        setLocaleVal(jaJP);
        i18n.changeLanguage(locale);
      }
    }
  }, [currentLocale]);

  return (
    <CustomProvider theme={darkMode ? 'dark' : 'light'}>
      <CookiesProvider>
        <CustomProvider locale={localeVal}>
          <Routing darkMode={darkMode} setDarkMode={setDarkMode}></Routing>
        </CustomProvider>
      </CookiesProvider>
    </CustomProvider>
  );
}

export default App;
